import BannerSettingsRedirect from './BannerSettingsRedirect'

export default BannerSettingsRedirect
